
<div class="row">
  <div class="col notification" :class="{ 'notification--showing': show }">
    <p class="notification__wrapper">
      <span class="notification__message">{{ message }}</span>
    </p>
  </div>
</div>
